// extracted by css-extract-rspack-plugin
export default {"button":"CommandPill-module__button__AvnQL","text":"CommandPill-module__text__PhF8n"};